import enquire from 'enquire.js';
import breakpoints from '../breakpoints';

const NS = 'navFlyout';
const activeModifier = 'is-flyout-active';
const navDelay = 150;

const NavFlyout = class {

    constructor() {
        this.$flyout = $('.js-nav-flyout');

        enquire.register(breakpoints.portable, {

            match: () => {
                this.$flyout.on(`click.${NS}`,
                    '.nav-primary__caret', (event) => {
                        event.preventDefault();
                        this.handleToggle(event.delegateTarget);
                    });
            },

            unmatch: () => {
                this.$flyout.off(`click.${NS}`);
            },
        });

        enquire.register(breakpoints.desk, {

            match: () => {

                this.$flyout.on(`mouseenter.${NS}`, (event) => {
                    this.handleMouseEnter(event.currentTarget);
                });

                this.$flyout.on(`mouseleave.${NS}`, (event) => {
                    this.handleMouseLeave(event.currentTarget);
                });
            },

            unmatch: () => {
                this.$flyout.off(`mouseenter.${NS} mouseleave.${NS}`);
            },
        });

    }

    showFlyout(flyout) {
        $(flyout).addClass(activeModifier);
    }

    hideFlyout(flyout) {
        $(flyout).removeClass(activeModifier);
    }

    handleToggle(flyout) {
        $(flyout).toggleClass(activeModifier);
    }

    handleMouseEnter(flyout) {

        clearTimeout($(flyout).data('hideTimer'));

        $(flyout).data('hideTimer', setTimeout(() => {
            this.showFlyout(flyout);
        }, navDelay));
    }

    handleMouseLeave(flyout) {

        clearTimeout($(flyout).data('hideTimer'));

        $(flyout).data('hideTimer', setTimeout(() => {
            this.hideFlyout(flyout);
        }, navDelay));
    }
};

new NavFlyout();

